import { setSessionStorageItem } from '../../sessionStorage/utils';
import { SESSION_STORAGE_LAST_BOOKED_RESERVATION } from '../../../utils/constants';

export default (bookedReservationVar) => {
  return (newHeldReservation) => {
    bookedReservationVar(newHeldReservation);
    setSessionStorageItem(SESSION_STORAGE_LAST_BOOKED_RESERVATION, newHeldReservation);
  };
};
